<template>
  <div class="d-flex justify-end align-center left-controller">
    <div class="pa-4 elevation-1" style="border-radius: 4px">
      <v-checkbox
        :input-value="outerFacadeVisibility['virtupet-name-tag']"
        @change="onClickCheckBox('virtupet-name-tag', $event)"
        label="이름 보이기"
        dense
        hide-details
      ></v-checkbox>
      <!-- 레벨·경험치: exp_setting(통합 컬럼) 제어. 가시성 소켓 토글 + 색상 변경 다이얼로그 -->
      <div class="d-flex align-center">
        <v-checkbox
          :input-value="expVisible"
          @change="onToggleExp($event)"
          label="레벨·경험치 보이기"
          dense
          hide-details
        ></v-checkbox>
        <v-btn icon x-small class="ml-1" title="색상 변경" @click="expDialog = true">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <v-checkbox
        :input-value="outerFacadeVisibility['sync-status']"
        @change="onClickCheckBox('sync-status', $event)"
        label="동기화 보이기"
        dense
        hide-details
      >
      </v-checkbox>
      <!-- 연결상태(sub status) 3모드: always(항상)/error(에러시에만·기본)/off(꺼짐).
           스위치 토글 = error↔off, 세부 선택은 연필(다이얼로그). 저장+발행 경로는 다른 보이기와 동일. -->
      <div class="d-flex align-center">
        <v-checkbox
          :input-value="connStatusMode !== 'off'"
          @change="setConnStatusMode($event ? 'error' : 'off')"
          label="연결상태 보이기"
          dense
          hide-details
        ></v-checkbox>
        <v-btn icon x-small class="ml-1" title="표시 방식" @click="connDialog = true">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <!-- 배경화면: background_setting(통합 컬럼) 제어. 소켓 라이브 토글 + 변경 다이얼로그 -->
      <div class="d-flex align-center">
        <v-checkbox
          :input-value="backgroundVisible"
          @change="onToggleBackground($event)"
          label="배경화면 보이기"
          dense
          hide-details
        ></v-checkbox>
        <v-btn icon x-small class="ml-1" title="배경 변경" @click="openBgDialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <!-- 좌우반전: 모델 미러. background처럼 DB(is_reverse_model) + 소켓 라이브 -->
      <v-checkbox
        :input-value="isReverseModel"
        @change="onToggleReverse($event)"
        label="좌우반전"
        dense
        hide-details
      ></v-checkbox>
      <!-- 파워 이펙트: effect_setting(통합 컬럼) 제어. 채팅 "ㅋ"에 반응해 모델 뒤 파티클 발동. 소켓 라이브 + DB -->
      <div class="d-flex align-center">
        <v-checkbox
          :input-value="effectEnabled"
          @change="onToggleEffect($event)"
          label="콤보 이펙트"
          dense
          hide-details
        ></v-checkbox>
        <v-btn icon x-small class="ml-1" title="이펙트 스타일 변경" @click="effectDialog = true">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <!-- 음소거: 체크하면 on-air BroadcastBox 오디오 mute. 소켓 라이브 + is_muted DB -->
      <v-checkbox :input-value="isMuted" @change="onToggleMute($event)" label="음소거" dense hide-details></v-checkbox>
      <!-- <v-checkbox
        :input-value="outerFacadeVisibility['sync-status']"
        @change="onClickCheckBox('sync-status', $event)"
        label="시스템 상태창 보이기"
        dense
        hide-details
      >
      </v-checkbox> -->
    </div>

    <!-- 연결상태 표시 방식: 3모드 배타 선택 -->
    <base-dialog v-model="connDialog" title="연결상태 표시 방식" :max-width="360">
      <v-checkbox
        :input-value="connStatusMode === 'always'"
        label="항상 보이기"
        dense
        hide-details
        @change="$event && setConnStatusMode('always')"
      ></v-checkbox>
      <v-checkbox
        :input-value="connStatusMode === 'error'"
        label="에러시에만 보이기"
        dense
        hide-details
        @change="$event && setConnStatusMode('error')"
      ></v-checkbox>
      <v-checkbox
        :input-value="connStatusMode === 'off'"
        label="항상 꺼짐"
        dense
        hide-details
        @change="$event && setConnStatusMode('off')"
      ></v-checkbox>
      <p class="text-caption grey--text mt-3 mb-0">
        "에러시에만 보이기"는 연결에 문제가 생겼을 때만 송출 화면에 상태를 표시해요.
      </p>
    </base-dialog>

    <!-- 배경화면 변경: 보유 배경 선택 → DB update + 소켓 라이브 반영 -->
    <base-dialog v-model="bgDialog" title="배경화면 변경" :max-width="520">
      <div v-if="!ownedBackgrounds.length" class="text-caption grey--text py-4 text-center">
        보유한 배경이 없어요. 스토어에서 구매해보세요.
      </div>
      <div v-else class="bg-picker">
        <div
          v-for="bg in ownedBackgrounds"
          :key="bg.fileName"
          class="bg-picker__item"
          :class="{ 'bg-picker__item--on': bg.fileName === backgroundFileName }"
          @click="selectBackground(bg)"
        >
          <div class="bg-picker__preview"><lottie-preview :file-name="bg.fileName"></lottie-preview></div>
          <div class="bg-picker__label">{{ bg.label }}</div>
        </div>
      </div>
    </base-dialog>

    <!-- 이펙트 스타일 변경: 프리셋별 미리보기(자동 발동) 그리드에서 선택 → DB update + 소켓 라이브 -->
    <base-dialog v-model="effectDialog" title="이펙트 스타일" :max-width="520">
      <div class="fx-picker">
        <div
          v-for="opt in effectStyleOptions"
          :key="opt.value"
          class="fx-picker__item"
          :class="{ 'fx-picker__item--on': opt.value === effectStyle }"
          @click="selectEffectStyle(opt.value)"
        >
          <div class="fx-picker__preview"><effect-preview :preset="opt.value"></effect-preview></div>
          <div class="fx-picker__label">{{ opt.text }}</div>
        </div>
      </div>
    </base-dialog>

    <!-- 레벨·경험치 색상 변경 (프리셋 스와치만 가볍게 픽) -->
    <base-dialog v-model="expDialog" title="레벨·경험치 색상" :max-width="320">
      <div class="d-flex justify-center">
        <v-color-picker
          v-model="expColor"
          :swatches="expSwatches"
          show-swatches
          hide-canvas
          hide-inputs
          hide-sliders
          flat
        ></v-color-picker>
      </div>
      <template #actions>
        <v-btn text @click="expDialog = false">취소</v-btn>
        <v-btn color="#8e6fd6" class="white--text" @click="applyExpColor">적용</v-btn>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import SupabaseApi from "@/api/SupabaseApi";
import { getVirtupetPubSocket } from "@/domain/stream/pub/VirtupetPubSocket";
import { DEFAULT_OUTER_FACADE_VISIBILITY } from "@/schema/FullSchema";
import { resolveConnStatusMode } from "@/schema/FullSchema";
import LottiePreview from "@/components-model/LottiePreview.vue";

export default {
  components: { LottiePreview },
  props: {
    petId: { type: String, default: null }, // 제어할 펫 (pub 라우팅 키)
  },
  async created() {
    const setting = (await SupabaseApi.PetBroadcastSetting.fetchBroadcastSetting()) || {};
    this.outerFacadeVisibility = setting.outerFacadeVisibility || DEFAULT_OUTER_FACADE_VISIBILITY;
    // 배경 통합 설정: 파일명(보존용)·가시성
    const bg = setting.backgroundSetting || {};
    this.backgroundFileName = bg.file_name || null;
    this.backgroundVisible = bg.visible !== false;
    this.isReverseModel = !!setting.isReverseModel;
    // 레벨·경험치 통합 설정
    const exp = setting.expSetting || {};
    this.expVisible = exp.visible !== false;
    this.expColor = exp.color || "#9155fd";
    // 파워 이펙트 통합 설정
    const fx = setting.effectSetting || {};
    this.effectEnabled = !!fx.enabled;
    this.effectStyle = fx.style || "particles";
    // 음소거
    this.isMuted = !!setting.isMuted;

    this.$emit("change", this.outerFacadeVisibility);
  },
  data() {
    return {
      outerFacadeVisibility: DEFAULT_OUTER_FACADE_VISIBILITY,
      backgroundVisible: true,
      backgroundFileName: null,
      isReverseModel: false,
      bgDialog: false,
      connDialog: false, // 연결상태 표시 방식 다이얼로그
      ownedBackgrounds: [], // [{ label, fileName }] 변경 다이얼로그용(열 때 로드)
      expVisible: true,
      expColor: "#9155fd",
      expDialog: false,
      // 파워 이펙트
      effectEnabled: false,
      effectStyle: "particles",
      effectDialog: false,
      // 음소거
      isMuted: false,
      effectStyleOptions: [
        { text: "색종이", value: "particles" },
        { text: "불꽃놀이", value: "fireworks" },
        { text: "불꽃", value: "flames" },
        { text: "반짝이", value: "magic" },
        { text: "하트", value: "heart" },
      ],
      // 프리셋 스와치(열 단위 배열). 가볍게 픽.
      expSwatches: [
        ["#9155FD", "#7C4DFF", "#3AA0FF"],
        ["#FF4FA3", "#FF6B6B", "#FFB020"],
        ["#00C2A8", "#A0E426", "#E879F9"],
        ["#FFFFFF", "#9E9E9E", "#000000"],
      ],
    };
  },
  computed: {
    // 저장값(레거시 boolean 포함) → 3모드 정규화
    connStatusMode() {
      return resolveConnStatusMode(this.outerFacadeVisibility["connection-status"]);
    },
  },
  methods: {
    // 연결상태 3모드 설정: 저장 + 소켓 발행 (값이 boolean이 아니라 모드 문자열)
    async setConnStatusMode(mode) {
      await this.onClickCheckBox("connection-status", mode);
    },
    async onClickCheckBox(targetEl, isVisible) {
      this.$set(this.outerFacadeVisibility, targetEl, isVisible); // 구 저장맵에 키가 없어도 반응성 보장

      getVirtupetPubSocket(this.petId).requestUpdateVisibility(`outerFacade#${targetEl}`, isVisible);

      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({
        outerFacadeVisibility: this.outerFacadeVisibility,
      });

      this.$emit("change", this.outerFacadeVisibility);
    },
    // 배경화면 보이기: 소켓으로 모든 BroadcastBox 라이브 토글 + background_setting.visible DB 저장(파일명 보존)
    async onToggleBackground(isVisible) {
      this.backgroundVisible = isVisible;
      getVirtupetPubSocket(this.petId).requestUpdateVisibility("outerFacade#background-canvas", isVisible);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({
        backgroundSetting: { file_name: this.backgroundFileName, visible: isVisible },
      });
    },
    // 레벨·경험치 보이기: 가시성 소켓 토글(exp-bar-layer div) + exp_setting.visible DB 저장(색 보존)
    async onToggleExp(isVisible) {
      this.expVisible = isVisible;
      getVirtupetPubSocket(this.petId).requestUpdateVisibility("outerFacade#exp-bar-layer", isVisible);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({
        expSetting: { visible: isVisible, color: this.expColor },
      });
    },
    // 레벨·경험치 색상 적용: 소켓 라이브 + exp_setting.color DB 저장(가시성 보존)
    async applyExpColor() {
      getVirtupetPubSocket(this.petId).requestUpdateExpColor(this.expColor);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({
        expSetting: { visible: this.expVisible, color: this.expColor },
      });
      this.expDialog = false;
    },
    // 좌우반전: 소켓 라이브 반영 + is_reverse_model DB 저장
    async onToggleReverse(isReverse) {
      this.isReverseModel = isReverse;
      getVirtupetPubSocket(this.petId).requestUpdateModelReverse(isReverse);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({ isReverseModel: isReverse });
    },
    // 파워 이펙트 on/off: 소켓 라이브 반영 + effect_setting DB 저장(스타일 보존)
    async onToggleEffect(enabled) {
      this.effectEnabled = enabled;
      getVirtupetPubSocket(this.petId).requestUpdateEffect(enabled, this.effectStyle);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({
        effectSetting: { enabled, style: this.effectStyle },
      });
    },
    // 음소거: 소켓 라이브 반영 + is_muted DB 저장
    async onToggleMute(muted) {
      this.isMuted = muted;
      getVirtupetPubSocket(this.petId).requestUpdateMute(muted);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({ isMuted: muted });
    },
    // 파워 이펙트 스타일 선택(다이얼로그): 소켓 라이브 반영 + effect_setting DB 저장(on/off 보존) → 닫기
    async selectEffectStyle(style) {
      this.effectStyle = style;
      getVirtupetPubSocket(this.petId).requestUpdateEffect(this.effectEnabled, style);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({
        effectSetting: { enabled: this.effectEnabled, style },
      });
      this.effectDialog = false;
    },
    // 변경 다이얼로그: 보유 배경 로드 후 오픈
    async openBgDialog() {
      if (!this.ownedBackgrounds.length) {
        this.ownedBackgrounds = await SupabaseApi.Item.fetchOwnedBackgrounds();
      }
      this.bgDialog = true;
    },
    // 배경 선택 → 파일 변경(+보이게). 소켓 라이브 반영 + background_setting DB 저장.
    async selectBackground(bg) {
      this.backgroundFileName = bg.fileName;
      this.backgroundVisible = true; // 변경 = 보이게
      getVirtupetPubSocket(this.petId).requestUpdateBackground(bg.fileName, true);
      await SupabaseApi.PetBroadcastSetting.updateBroadcastSetting({
        backgroundSetting: { file_name: bg.fileName, visible: true },
      });
      this.bgDialog = false;
    },
  },
};
</script>

<style scoped>
/* 라벨 클릭은 무시 — 체크박스 박스를 눌러야만 토글 */
.left-controller >>> .v-label {
  pointer-events: none;
}
/* 배경 변경 다이얼로그 그리드 */
.bg-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}
.bg-picker__item {
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
}
.bg-picker__item--on {
  border-color: #8e6fd6;
}
.bg-picker__preview {
  height: 90px;
  background: #fff;
}
.bg-picker__label {
  text-align: center;
  font-size: 12px;
  padding: 4px 0;
}
/* 이펙트 스타일 미리보기 그리드 (파티클이 보이도록 어두운 카드) */
.fx-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
}
.fx-picker__item {
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #14141c;
}
.fx-picker__item--on {
  border-color: #8e6fd6;
}
.fx-picker__preview {
  height: 96px;
}
.fx-picker__label {
  text-align: center;
  font-size: 12px;
  padding: 4px 0;
  color: #dcdce6;
}
</style>
